import * as ProgressPrimitive from '@radix-ui/react-progress';
import * as React from 'react';

import { cn } from '@/lib/utils';
import { useEffect } from 'react';

function Progress({
  className,
  value,
  ...props
}: React.ComponentProps<typeof ProgressPrimitive.Root>) {
  const [animatedValue, setAnimatedValue] = React.useState(0);

  useEffect(() => {
    // Animate from 0 to the target value on mount and when value changes
    const timeout = setTimeout(() => {
      setAnimatedValue(value || 0);
    }, 300);

    return () => clearTimeout(timeout);
  }, [value]);

  const max = props.max ?? 100;
  const percentage =
    max > 0
      ? Math.min(100, Math.max(0, ((animatedValue ?? 0) / max) * 100))
      : 0;

  return (
    <ProgressPrimitive.Root
      data-slot="progress"
      className={cn(
        'bg-primary/20 relative h-2 w-full overflow-hidden rounded-full',
        className,
      )}
      {...props}>
      <ProgressPrimitive.Indicator
        data-slot="progress-indicator"
        className="bg-primary h-full w-full flex-1 rounded-full transition-all duration-1000"
        style={{
          transform: `translateX(-${100 - percentage}%)`,
        }}
      />
    </ProgressPrimitive.Root>
  );
}

export { Progress };
